import {isNil} from 'lodash';

import styles from 'src/js/common/components/formatters/IntegerFormatter.less';
import baseIntegerFormatterParams from 'src/js/lib/raw_rendering/base_integer_formatter_params';

/**
 * Returns raw Html version of IntegerFormatter component.
 * @param params
 * @returns {String}
 */
export default function integerFormatter(params) {
  const {value, formattedValue} = baseIntegerFormatterParams(params);
  return !isNil(value)
    ? `<div class="${styles.dlIntegerFormatter}" title="${formattedValue}">
            ${formattedValue}
        </div>`
    : '';
}
